import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[appDecimalvalues]',
    standalone: false
})
export class DecimalvaluesDirective {

  constructor(private el: ElementRef) { }
  
  @HostListener('input', ['$event']) onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Allow only one dot and numeric characters
    if (value.split('.').length > 2 || /[^0-9.]/.test(value)) {
      input.value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
    }
  }
}
